import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHardwareBack } from 'Hooks/useHardwareBack';

/**
 * The repertoire player's Back: the header's on-screen Back, and Android's hardware or gesture
 * Back while the player is on screen. Both go to the repertoire, wherever the player was opened
 * from (the roadmap, or the lesson's "repertoire unlocked" page). Returns the on-screen Back.
 */
export const useRepertoirePlayBack = (): (() => void) => {
  const navigate = useNavigate();
  // Set once Back has asked for the repertoire: a second press before it renders does not
  // navigate again.
  const leavingRef = useRef(false);
  const backToRepertoire = useCallback(() => {
    if (leavingRef.current) return;
    leavingRef.current = true;
    navigate('/repertoire');
  }, [navigate]);
  useHardwareBack('/repertoire-play', backToRepertoire);
  return backToRepertoire;
};
